import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { usePostHog } from '../components/PostHogProvider';

export const usePostHogAuth = () => {
  const { user, isAuthenticated, isLoading } = useAuth0();
  const { posthog, isInitialized } = usePostHog();

  useEffect(() => {
    if (!isInitialized || !posthog) return;

    if (isAuthenticated && user) {
      // Identify the user in PostHog
      posthog.identify(user.sub, {
        email: user.email,
        name: user.name,
        nickname: user.nickname,
        email_verified: user.email_verified,
        updated_at: user.updated_at,
        auth0_user_id: user.sub,
      });

      // Set user properties
      posthog.setPersonProperties({
        email: user.email,
        name: user.name,
        nickname: user.nickname,
        email_verified: user.email_verified,
        updated_at: user.updated_at,
        auth0_user_id: user.sub,
      });

      // Track login event
      // posthog.capture('user_logged_in', {
      //   distinct_id: user.sub,
      //   email: user.email,
      //   timestamp: new Date().toISOString()
      // });

      console.log('PostHog: User identified and logged in event tracked');
    } else if (!isAuthenticated && !isLoading) {
      // Track logout event - simplified without getDistinctId check
      // posthog.capture('user_logged_out', {
      //   distinct_id: user.sub,
      //   email: user.email,
      //   timestamp: new Date().toISOString()
      // });
      console.log('PostHog: User logged out event tracked');
    }
  }, [isAuthenticated, user, isLoading, posthog, isInitialized]);

  return { posthog, isInitialized };
}; 